
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.894 14.73a4.195 4.195 0 01-.494-.513A3.846 3.846 0 015 13.623h-2.81c-.357 0-.627-.09-.81-.268-.183-.178-.275-.44-.275-.783V2.17c0-.339.092-.601.275-.787.183-.185.453-.278.81-.278h7.18c.343 0 .609.093.796.278.188.186.282.448.282.787v5.997c.21.11.409.242.594.395.186.154.357.32.512.498V2.157c0-.719-.177-1.258-.532-1.618C10.668.18 10.135 0 9.425 0H2.13C1.424 0 .893.18.536.543.179.905 0 1.443 0 2.157v10.415c0 .719.177 1.258.532 1.618.355.36.888.54 1.598.54h3.764zM8.388 3.908c.12 0 .22-.042.302-.127a.423.423 0 00.124-.306.417.417 0 00-.426-.412H3.181a.423.423 0 00-.313.12.397.397 0 00-.12.292c0 .12.04.221.12.306a.41.41 0 00.313.127h5.207zm0 2.39c.12 0 .22-.04.302-.123a.411.411 0 00.124-.302.417.417 0 00-.426-.42H3.181a.423.423 0 00-.313.12c-.08.081-.12.18-.12.3a.417.417 0 00.433.426h5.207zM12.201 16c.16 0 .293-.056.398-.168a.602.602 0 00-.034-.849l-1.566-1.57.045-.064a2.986 2.986 0 00.511-1.705 3 3 0 00-.415-1.559 3.169 3.169 0 00-1.117-1.12 2.968 2.968 0 00-1.552-.419c-.568 0-1.086.14-1.553.42-.467.279-.842.653-1.123 1.122-.282.47-.423.989-.423 1.557 0 .567.141 1.085.423 1.552.281.467.656.84 1.123 1.116.467.277.985.416 1.553.416s1.085-.138 1.552-.416l.136-.085 1.54 1.545a.696.696 0 00.502.227zm-3.73-2.253c-.39 0-.744-.095-1.062-.285a2.2 2.2 0 01-.766-.763 2 2 0 01-.288-1.054 2 2 0 01.288-1.055c.193-.318.448-.574.766-.766a2.012 2.012 0 011.062-.289c.38 0 .729.097 1.047.289a2.2 2.2 0 01.763.766c.19.318.285.67.285 1.055 0 .384-.095.736-.285 1.054-.19.318-.443.572-.76.763-.315.19-.666.285-1.05.285z","fill":"#175F69"}})])
          )
        }
      }
    